import { Controller } from 'stimulus';

// Transient bridge between a turbo_stream update and a live Tabulator table.
//
// After a stream swaps a single row group's source <tbody> in place (e.g.
// the Alert Recap page re-rendering one property's rows on save), it appends
// an element bound to this controller. On connect we tell the page's
// `tabulator-table` controller to reconcile that group's rows into its live
// dataset (`syncRowGroup`), then remove ourselves so repeated saves don't
// accumulate stale trigger nodes.
//
// The <tbody> swap always precedes the append in the stream, so by the time
// this connects the source table already reflects the new rows.
export default class extends Controller {
  static values = { group: String, groupOrder: Array, syncGroups: Boolean };

  connect() {
    const table = document.querySelector(
      '[data-controller~="tabulator-table"]'
    );
    if (table) {
      // Grouped tables: redeclare the groups first when the stream added or
      // removed one. Order matters — Tabulator silently drops a row whose
      // group isn't in the declared set, so a row synced before its group is
      // declared would vanish. An empty order is meaningful (the last group is
      // gone), hence the separate opt-in flag.
      if (this.syncGroupsValue) {
        table.dispatchEvent(
          new CustomEvent('tabulator-table:sync-groups', {
            detail: { groupOrder: this.groupOrderValue },
          })
        );
      }
      table.dispatchEvent(
        new CustomEvent('tabulator-table:sync-group', {
          detail: { group: this.groupValue },
        })
      );
    }
    this.element.remove();
  }
}
